import React, { useState, useEffect, useMemo } from "react";
import { Theme, StandardProps } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import { StyleClassKey } from "js/react/typescript";

import { TextFieldWithError, AppButton } from "js/react/components";
import { DialogProps } from "@material-ui/core/Dialog";
import { getFieldState, ValidityState, isStateValid } from "js/types";
import {
    Validations,
    applyValidations,
    InputValidationRule
} from "js/helpers/ValidationHelpers";
import { DialogTitle } from "@material-ui/core";
import { Dialog } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";
import { DialogActions } from "@material-ui/core";

const styles = (theme: Theme) =>
    createStyles({
        root: {},
        title: {},
        content: {
            marginTop: theme.spacing(1),
            minWidth: 400
        },
        btn: {},
        fullWidth: {}
    });

type RenameDirectoryDialogClassKey = StyleClassKey<typeof styles>;

const useStyles = makeStyles(styles);

export interface RenameDirectoryDialogProps
    extends StandardProps<DialogProps, RenameDirectoryDialogClassKey> {
    loading: boolean;
    name: string;
    validityState: ValidityState;
    onCancel: () => void;
    onRename: (name: string) => void;
}

function Component(props: RenameDirectoryDialogProps) {
    const classes = useStyles(props);
    const {
        classes: cls,
        loading,
        onRename,
        validityState,
        name: existingName,
        ...rest
    } = props;
    const [name, setName] = useState(existingName);
    const validationRule: InputValidationRule[] = [
        { rule: Validations.REQUIRED, message: "Name is required" }
    ];
    const [errorState, setErrorState] = useState(validityState);
    useEffect(() => {
        setErrorState(validityState);
    }, [validityState]);
    const initialErrors = useMemo(() => {
        return applyValidations([], validationRule, name, "directoryName");
    }, [errorState, name]);

    return (
        <Dialog className={classes.root} {...rest}>
            <DialogTitle>Enter name</DialogTitle>
            <DialogContent className={classes.content}>
                <TextFieldWithError
                    label={"Name"}
                    id={"name"}
                    errorInfo={getFieldState(initialErrors, "directoryName")}
                    value={name}
                    required
                    onChange={event => {
                        const val = event.target.value;
                        setName(val);
                    }}
                />
            </DialogContent>
            <DialogActions>
                <AppButton
                    className={classes.btn}
                    disabled={loading || !isStateValid(initialErrors)}
                    onClick={e => onRename(name)}
                >
                    Rename
                </AppButton>
            </DialogActions>
        </Dialog>
    );
}

Component.defaultProps = {} as RenameDirectoryDialogProps;
Component.displayName = "RenameDirectoryDialog";
export const RenameDirectoryDialog = Component;
export default RenameDirectoryDialog;
